module.exports = __webpack_public_path__ + "static/media/pic13.9d791a48.jpg";